import { useEffect } from "react";
import { isEmpty, noop } from "lodash";
import { PageMetaData } from "@circle-react/components/Layout/PageMetaData";
import { usePunditUserContext } from "@circle-react/contexts";
import { isLive } from "@circle-react/helpers/liveStreamRoomHelpers";
import { ToastProvider } from "@circle-react-uikit/ToastV2";
import { Header } from "../Room/Header";
import { LiveLoader } from "../Room/LiveLoader";
import { InfoButton } from "./Buttons/InfoButton";
import { Footer } from "./Footer";
import { InfoBox } from "./InfoBox";
import { LandingPage } from "./LandingPage";
import { StreamIsFull } from "./LandingPage/StreamIsFull";
import { Player } from "./Player";
import { PreJoinModal } from "./PreJoinModal";
import { Sidebar } from "./Sidebar";
import {
  useCommunityMemberRedirect,
  useNotSupportedRedirect,
  usePublicLiveStreamRoom,
} from "./hooks";
import { usePublicLiveStore } from "./store";

export const PublicStream = () => {
  useNotSupportedRedirect();
  useCommunityMemberRedirect();
  const { currentCommunityMember, isLoading: isCommunityLoading } =
    usePunditUserContext();

  const {
    room,
    isLoading: isRoomLoading,
    isError,
    error,
  } = usePublicLiveStreamRoom();
  const {
    hasLeftStream,
    isGuestPromptOpen,
    isInfoBoxOpen,
    actions: { setGuestName, toggleInfoBox },
  } = usePublicLiveStore();
  const isLoading = isRoomLoading || isCommunityLoading;
  const shouldDisplayLandingPage = !isLive(room) || !room || hasLeftStream;
  const isFull = isError && error?.status === 403;

  useEffect(() => {
    if (!isCommunityLoading && !isEmpty(currentCommunityMember)) {
      setGuestName(currentCommunityMember?.name || "");
    }
  }, [isCommunityLoading, currentCommunityMember, setGuestName]);

  if (isLoading) {
    return (
      <div className="bg-primary absolute">
        <LiveLoader />
      </div>
    );
  }

  if (isFull) {
    return <StreamIsFull />;
  }

  if (shouldDisplayLandingPage) {
    return <LandingPage room={room} hasLeftStream={hasLeftStream} />;
  }

  const infoButton = room?.description ? (
    <InfoButton onClick={toggleInfoBox} />
  ) : (
    noop
  );

  return (
    <ToastProvider defaultOptions={{ placement: "top" }}>
      <PageMetaData title={room.name} bodyClassNames="overflow-hidden">
        <div className="flex h-screen w-screen bg-[#191b1f]">
          <div className="flex grow flex-col">
            <Header room={room} infoButton={infoButton} isPublic />
            <div className="relative grow px-6">
              <Player hlsUrl={room.hls_url} />
              {isInfoBoxOpen && <InfoBox room={room} />}
            </div>
            <Footer room={room} />
          </div>
          <Sidebar />
        </div>
        {isGuestPromptOpen && <PreJoinModal isOpen={isGuestPromptOpen} />}
      </PageMetaData>
    </ToastProvider>
  );
};

export default PublicStream;
